// extracted by mini-css-extract-plugin
export var arrowContainer = "Tiles-module__arrowContainer--1PsmR";
export var arrowReturnContainer = "Tiles-module__arrowReturnContainer--1Aiqn";
export var square = "Tiles-module__square--2Ygit";
export var squareItems = "Tiles-module__squareItems--3JOh4";
export var squareTitleIconContainer = "Tiles-module__squareTitleIconContainer--Un-2W";
export var squaresContainer = "Tiles-module__squaresContainer--3W38V";
export var subTitleContainer = "Tiles-module__subTitleContainer--3GaWj Tiles-module__textsContainer--1smsK";
export var textsContainer = "Tiles-module__textsContainer--1smsK";
export var tilesContainer = "Tiles-module__tilesContainer--2Q6CV";
export var title = "Tiles-module__title--1S6A0 Tiles-module__textsContainer--1smsK";